import SavedQueryLink from './SavedQueryLink';

export default SavedQueryLink;
